@import "../../variables.scss";

.declarationform {
  &__subtext {
    font-size: 13px;
    color: $color-grey;
    margin-top: 0.5rem;
  }
}

.inductionform__subtext {
  font-size: 13px;
  color: $color-grey;
  margin-top: 0.5rem;
}

.submitButtonDesktop {
  width: 60%;
  display: flex;
  text-align: start;
  margin-right: 1.5rem;
}

@media only screen and (max-width: 576px) {
  .submitButtonDesktop {
    visibility: hidden;
    height: 0;
    width: 0;
    margin: 0;
  }
}
